export default class Enum {
  constructor(obj) {
    if (!obj) obj = {};

    this.id = obj.id ? obj.id : "";
    this.name = obj.name ? obj.name : "";
  }
}
